import { EventEmitter, HostListener, Injectable, Output } from '@angular/core';
import { BasePesquisaComponent } from './base-pesquisa.component';

@Injectable()
export class ModalPesquisaService {
  componente: BasePesquisaComponent | null = null;

  constructor() { }

  setarComponenteBase(componente: BasePesquisaComponent) {
    this.componente = componente;
  }

  abrir() {
    if (this.componente === null) throw 'this.componente is null.';

    this.componente.abrir();
  }

  abrirTelaCheia() {
    if (this.componente === null) throw 'this.componente is null.';

    this.componente.abrirTelaCheia();
  }

  fechar() {
    if (this.componente === null) throw 'this.componente is null.';

    this.componente.fechar();
  }
}
